import { BinaryRenderer } from '@/widgets/components/binary-renderer';
import React, { useState } from 'react';
import { Faq, Features, Glossary } from '../help-config';
import { HELP_TABS } from '../help-constants';
import { HelpPageLink } from './help-page-header';
import {
  BulletedList,
  ListItem,
  MainContentWrapper,
  StyledInput,
  VerticalBar,
  Wrapper,
} from './help-sidebar-nav-styles';

/*
 * Helper method to scroll items into view.
 * @param {*} Element Parent container which enables scroll on overflow.
 * @param {*} ref - ref dictionary which holds refs to items which can be scrolled into view.
 * @param {*} key - key for item which should be scrolled into view.
 * - 170 is used so that the content is not cut off by the tabs.
 */
const scrollToRef = (Element, ref, key) => {
  Element.scrollTo({
    left: 0,
    top: ref.current[key].offsetTop - 170,
    behavior: 'smooth',
  });
};

function NestedListItem(props) {
  return (
    <ListItem
      activeItem={props.activeItem}
      header={props.children}
      onClick={() => {
        props.setActiveItem(props.children);
        scrollToRef(
          props.contentContainerRef.current,
          props.refs,
          props.children
        );
      }}
    >
      {props.children}
    </ListItem>
  );
}

export function ListTopic(props) {
  const filteredContentList = props.nestedList.content.filter((content) =>
    content.header.toLowerCase().includes(props.searchValue.toLowerCase())
  );
  return (
    <>
      <ListItem
        header={props.header}
        active={props.activeFeature}
        onClick={() => props.setActiveFeature(props.header)}
      >
        {props.header}
      </ListItem>
      <BulletedList>
        {props.activeFeature === props.header &&
          filteredContentList.map((item, index) => (
            <NestedListItem
              header={props.header}
              key={index}
              activeItem={props.activeItem}
              setActiveItem={props.setActiveItem}
              contentContainerRef={props.contentContainerRef}
              refs={props.refs}
            >
              {item.header}
            </NestedListItem>
          ))}
      </BulletedList>
    </>
  );
}

export function FeaturesSideBarList(props) {
  const [activeItem, setActiveItem] = useState(null);
  return (
    <BulletedList>
      {Object.keys(props.contentList).map((key, index) => {
        return (
          <ListTopic
            key={index}
            header={key}
            searchValue={props.searchValue}
            activeFeature={props.activeFeature}
            setActiveFeature={props.setActiveFeature}
            activeItem={activeItem}
            setActiveItem={setActiveItem}
            nestedList={props.contentList[key]}
            refs={props.refs}
            contentContainerRef={props.contentContainerRef}
          />
        );
      })}
    </BulletedList>
  );
}

export function SideBarList(props) {
  const [activeItem, setActiveItem] = useState(null);
  const filteredContentList = props.contentList.filter((content) =>
    content.header.toLowerCase().includes(props.searchValue.toLowerCase())
  );
  return (
    <BulletedList>
      {filteredContentList.map((content, index) => (
        <ListItem
          key={index}
          header={content.header}
          activeItem={activeItem}
          onClick={() => {
            setActiveItem(content.header);
            scrollToRef(
              props.contentContainerRef.current,
              props.refs,
              content.header
            );
          }}
        >
          {content.header}
        </ListItem>
      ))}
    </BulletedList>
  );
}

export function HelpSidebarNav(props) {
  const [searchValue, setSearchValue] = useState('');
  return (
    <Wrapper>
      <VerticalBar>
        <HelpPageLink content="Help Center" onClick={props.returnOnClick} />
        <StyledInput
          placeholder={`Search ${props.activeNav}`}
          value={searchValue}
          onChange={(newVal) => setSearchValue(newVal)}
        />
        <MainContentWrapper>
          <BinaryRenderer checkpoint={props.activeNav === HELP_TABS.FAQ}>
            <SideBarList
              refs={props.refs}
              contentContainerRef={props.contentContainerRef}
              contentList={Faq}
              searchValue={searchValue}
            />
          </BinaryRenderer>
          <BinaryRenderer checkpoint={props.activeNav === HELP_TABS.FEATURES}>
            <BulletedList>
              <FeaturesSideBarList
                refs={props.refs}
                contentContainerRef={props.contentContainerRef}
                contentList={Features}
                activeFeature={props.activeFeature}
                setActiveFeature={props.setActiveFeature}
                searchValue={searchValue}
              />
            </BulletedList>
          </BinaryRenderer>
          <BinaryRenderer checkpoint={props.activeNav === HELP_TABS.GLOSSARY}>
            <BulletedList>
              <SideBarList
                refs={props.refs}
                contentContainerRef={props.contentContainerRef}
                contentList={Glossary}
                searchValue={searchValue}
              />
            </BulletedList>
          </BinaryRenderer>
        </MainContentWrapper>
      </VerticalBar>
    </Wrapper>
  );
}
